import { Layout, Button } from "antd";
import React, { useState, useEffect } from "react";
import { MainHeader } from "./main-header";
import { MainMenu } from "./main-menu";
import { Outlet } from "react-router-dom";
import { useId24 } from "../../drivers/id24/Id24Provider";
import { toggleOnId24 } from "../../configs";
import { IProfile } from "../common";
import BG from "../../assets/images/Admin_desktopBG.png";

const { Content, Sider, Footer } = Layout;
export const MainLayout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { authenticated, login, logout } = useId24();
  const [userRequestedLogout, setUserRequestedLogout] = useState(false);
  const [Profile] = useState<IProfile>();

  // const auth = useId24();
  // useEffect(() => {}, []);

  // const groupRoules: string[] = [];
  // if (auth) {
  //   auth.tokenAccess?.userAccess.map((groupId) => {
  //     groupId.roles.forEach(function (value, i) {
  //       groupRoules.push(value);
  //     });
  //   });
  // }

  useEffect(() => {}, [authenticated]);

  if (!authenticated) {
    if (userRequestedLogout) {
      login(window.location.href, false);
    } else {
      login(window.location.href, false);
    }
    return <Button onClick={() => login(window.location.href, false)}>Login</Button>;
  }

  return (
    <Layout>
      <Sider collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)}>
        <MainMenu />
      </Sider>
      <Layout>
        <MainHeader
          profile={Profile}
          onLogout={() => {
            setUserRequestedLogout(true);
            logout().then(() => login(window.location.href, false));
          }}
        />
        <Content className="pb-[24px] min-h-[80vh] bg-center bg-no-repeat bg-cover h-[80vh]" style={{ backgroundImage: `url(${BG})` }}>
          <Outlet />
        </Content>
        <Footer className="text-center bg-bottom bg-no-repeat bg-cover" style={{ backgroundImage: `url(${BG})`, color: "rgba(0,0,0,.45)" }}>
          <p>E - Connect | Version: 1.0.0</p>
        </Footer>
      </Layout>
    </Layout>
  );
};
